<template>
<div class="filtering-dropdown" :class="{ 'expanded': isExpanded }">
	<div class="filtering-dropdown-container" ref="main">

		<button class="filtering-dropdown-container-btn" @blur="checkFocus" @click="toggle">{{Label}} <span class="icon-arrow-down" :class="{ flipped: isExpanded }" ></span></button v-on:keyup.tab="checkFocus">

		<ul class="filtering-dropdown-list list-unstyled" v-if="isExpanded" >
			<li class="filtering-dropdown-list-item" @blur="checkFocus" @click="clickItem(item)" 
			
			v-for="(item, index) in items" tabindex="0" aria-role="option" :aria-selected="item.isChecked" v-on:keydown.space.stop.prevent="clickItem(item)" aria-live="polite" :aria-label="item.isChecked ? 'Checkbox: ' + item.Label + ' is checked' : 'Checkbox: ' + item.Label + ' is not checked'">
				<span class="filtering-dropdown-list-item-checkbox">
					<span class="filtering-dropdown-list-item-checkbox-check" v-if="item.isChecked"></span>
				</span>
				<span class="filtering-dropdown-list-item-text">
				{{item.Label}}
				</span>
			</li>
		</ul>

	</div>
	
</div>
</template>

<script>
	import Vue from 'vue'

export default {
	data() {
		return {
			isExpanded: false,
		}
	},
	props: { 
		items: 
		{
			type: Array,
			default: [
			]
		},
		Label: {
			type: String,
			default: ""
		}
	},
	mounted() {
	},
	methods: {
		clickItem(item) {

			item.isChecked = !item.isChecked;

		},
		checkFocus(e) {

			
			// if(!window.matchMedia("(max-width: 992px)").matches) {		// on mobile, don't check focus..
			// 	if(!this.$refs.main.contains(e.relatedTarget)) {
			// 		Vue.nextTick(() => {
			// 			this.isExpanded = false;	

			// 		});
			// 	}
			// }
		},
		toggle() {
			this.isExpanded = !this.isExpanded;
		},
		close() {
			this.isExpanded = false;
		}
	}
}
</script>

<style lang="scss">

	$listItemSize: 2.5em;

	.filtering-dropdown 
	{


		min-width: 180px;
		@include respond-above(xl) {
			min-width: 250px;
		}

		@include respond-below(lg) {
			width: 100%;
			margin-bottom: 0 !important;
		}

		&:focus, &:focus-within {
			outline: 1px solid $lightBlue;
			.filtering-dropdown-list {
				// 	outline: 1px solid $lightBlue;
			}
		}

		.filtering-dropdown-list-item-text {
			line-height: normal;
			// white-space: nowrap;
			// overflow: hidden;
			// text-overflow: ellipsis;
		}

		// margin-right: 2em;
		.filtering-dropdown-list-item-checkbox {
			border: 1px solid $lightGrey;
			height: $listItemSize;
			width: $listItemSize;
			display: inline-flex;
			flex-shrink: 0;
			justify-content: center;
			align-items: center;
			margin-right: 1em;


			.filtering-dropdown-list-item-checkbox-check {
    			height: 14px;
    			width: 16px;
    			display: inline-block;
				@include bgicon();
				background-image: get-icon( 'thin-check-icon', $lightBlue );
			}	
		}

		.filtering-dropdown-container
		{
			width: 100%;
			
			position: relative;
			// padding: 0.25em;
			box-sizing: content-box;
			border-top: 1px solid $lightGrey2;

			@include respond-above(lg) {
				background-color: $white;
				border: 1px solid $lightGrey;

				height: $listItemSize;
			}



			.filtering-dropdown-container-btn {
				color: $navyBlue;
				background: none;
				border: none;
				width: 100%;
				height: 100%;
				text-align: left;

				display: flex;
				flex-drection: row;
				justify-content: space-between;
				align-items: center;

				@include respond-below(lg) {
					padding: 1em 2em;
					color: $navyBlue;
				}
			}

			.filtering-dropdown-list {
				min-width: 212px;
				max-height: 360px;
				overflow-y: scroll;
				&::-webkit-scrollbar {
					display: block;
					width: 15px;
					// background-color: red;
				}
				&::-webkit-scrollbar-thumb {
				  background-color: $lightGrey;
				}
				@include respond-above(lg) {
					position: absolute;

					left: -1px;
					right: -1px;
					box-sizing: content-box;
					top: calc($listItemSize - 1px);
					background-color: $white;
					border: 1px solid $lightGrey;
					padding-bottom: 1em;

					z-index: 5;

				}

				.filtering-dropdown-list-item {

					display: flex;
					flex-drection: row;
					justify-content: flex-start;
					align-items: center;
					margin-top: 1em;
					cursor: pointer;
					width: 100%;
					padding: 0.5em;
					height: $listItemSize;
				}				
			}
		}

		.icon-arrow-down {
			@include bgicon();

			background-image: get-icon( 'arrow-down', $black );
			height: 0.68em;
			width: 1.5em;

			// transition: 0.4s all ease-in-out;

			&.flipped {
				transform: rotate(-180deg);
			}				


		}
	}
</style>